export const round = (num: number, precision: number = 0) => {
    const shift = (num2: number, precision2: number) => {
        const numArray = ('' + num2).split('e');

        return +(numArray[0] + 'e' + (numArray[1] ? +numArray[1] + precision2 : precision2));
    };

    return shift(Math.round(shift(num, +precision)), -precision);
};
